module.exports = __webpack_public_path__ + "images/comments.61b113d7b4730b0be3938eb8426dfcdf.svg";